import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hundredYenMontessori: BlogMetaData = {
  title: '100均で作るモンテッソーリ教具・おもちゃ｜年齢別・ねらい別 手作りアイデア12選【ダイソー・セリア】',
  description:
    '100均（ダイソー・セリア）の材料で作れるモンテッソーリ教具を年齢別（0〜3歳）・ねらい別（指先・感覚・言語・数）に12選厳選。実際の作り方手順とモンテッソーリ的なねらいを園長・保育士目線で解説します。',
  thumbnailUrl: '/img/blog-100yen-montessori.webp',
  filePath: buildBlogFilePath('100yen-montessori'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
